import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState } from '@/store/types';
import { MessageTypeFilter, MessageTypeItem, MessageTypesState } from './types';

export const actions: ActionTree<MessageTypesState, RootState> = {
  getMessageTypes: ({ commit }, data) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({ url: '/acapi/message_types', params: data })
        .then(resp => {
          commit('setMessageTypes', resp.data.message_types);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
  getMessageTypeItem: ({ commit }, id) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({ url: `/acapi/message_types/${id}` })
        .then((resp: any) => {
          let messageTypeItem = <MessageTypeItem>resp.data;
          messageTypeItem.id = id;
          commit('setMessageTypeItem', messageTypeItem);
          resolve(messageTypeItem)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
  saveMessageTypeItem: ({ commit, dispatch }, data: MessageTypeItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: data.id ? 'put' : 'post',
        url: '/acapi/message_types/' + (data.id ?? ''),
        data: data
      })
        .then((resp: any) => {
          dispatch('getMessageTypes');
          resolve(resp)
        })
        .catch((err: any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
  deleteMessageTypeItem: ({ commit, dispatch }, data: MessageTypeItem) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/acapi/message_types/${data.id}`,
        data: data
      })
        .then((resp: any) => {
          dispatch('getMessageTypes');
          resolve(resp)
        })
        .catch((err: any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false));
    })
  },
};